export default "/images/document-csv.svg?704aff46a576c63a0f02c9264445a5fd";